export default "__VITE_ASSET__B2L81O9b__"